import GlutenFreeIcon from '@discover-ui/icons/gluten-free.svg';
import VegetarianIcon from '@discover-ui/icons/vegetarian.svg';
import Tooltip from '@discover-ui/tooltip';
import { DIETARY_BADGE_LABELS, type DietaryBadgeId } from './dietaryBadges';

const ICONS = {
  glutenFree: GlutenFreeIcon,
  vegetarian: VegetarianIcon,
} as const;

export type PD6616DietaryBadgesProps = {
  badges: DietaryBadgeId[];
};

export default function PD6616DietaryBadges({ badges }: PD6616DietaryBadgesProps) {
  if (badges.length === 0) return null;

  return (
    <span className="inline-flex shrink-0 items-center gap-1.5">
      {badges.map((badge) => {
        const Icon = ICONS[badge];

        return (
          <Tooltip
            key={badge}
            content={DIETARY_BADGE_LABELS[badge]}
            className="size-4 text-ds-gray-light-700">
            <Icon width={16} height={16} aria-hidden="true" />
          </Tooltip>
        );
      })}
    </span>
  );
}
